import Handsontable from "handsontable";
import Core from "handsontable/core";
import { CellProperties } from "handsontable/settings";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

const customNullRepetitionRenderer = (
  instance: Core,
  td: HTMLTableCellElement,
  rowIndex: number,
  colIndex: number,
  prop: string | number,
  cell: MatrixParameterValue,
  cellProperties: CellProperties,
) => {
  Handsontable.renderers.TextRenderer.apply(instance, [instance, td, rowIndex, colIndex, prop, cell, cellProperties]);

  td.style.height = "2rem";
  td.style.backgroundColor = "#f0f0f0";
};

export default customNullRepetitionRenderer;
